import baseUrl from "../config/baseUrl";

const deleteFieldSettings = async ({ token, id }) => {
    const formData = new FormData();
    formData.append("id", id);

    try {
        const response = await fetch(
            `${baseUrl}/api/delete-field-setting-table-data?field_setting_id=${id}`,
            {
                method: "Delete",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            }
        );
        const data = await response.json();
        return data;
    } catch (error) {
        return error;
    }
};

export default deleteFieldSettings;
